import moment from 'moment'

const toTable = (request) => {
  return {
    id: request.id,
    user: request.user,
    status:  request.status,
    requested: moment(request.created_at).unix()
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(toTable)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/access-requests/getters.js